import http from "plugins/axios";

export default {
  getUserList(data) {
    return http.get({
      url: `/ta/admin/tenant/coin/getCoinPage`,
      data
    });
  },
  coinUpdate(data) {
    return http.post({
      url: `/ta/admin/tenant/coin/update`,
      data
    })
  },

  coinList(data) {
    return http.get({
      url: `/ta/admin/tenant/coin/list`,
      data
    })
  },
  tenantChainist() {
    return http.get({
      url: `/ta/admin/tenant/coin/chain/list`,
    })
  },

};
